<template>
  <Teleport to="body">
    <div
      class="z-10000 fixed left-4 top-[calc(var(--status-bar-height)+64px)] flex w-[calc(100%-32px)] justify-center"
    >
      <FreeAlert ref="alertRef" :duration="2000">
        <template #icon>
          <img
            src="@/assets/images/green-copy-icon.svg"
            width="24"
            height="24"
            alt=""
            role="presentation"
          />
        </template>
        <p class="text-text-neutral-primary">
          {{ $t('common.promocodeCopied') }}
        </p>
      </FreeAlert>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue';
  import { FreeAlert } from 'freedom-shared';
  import { copyText } from '@aviata/copy-text';

  interface BannerClickDetail {
    promocode?: string;
  }

  const alertRef = ref<InstanceType<typeof FreeAlert> | null>(null);

  const handleBannerClick = (event: Event) => {
    const { promocode } = (event as CustomEvent<BannerClickDetail>).detail;

    if (!promocode) return;

    copyText(promocode).then(() => {
      alertRef.value?.show();
    });
  };

  onMounted(() => {
    document.addEventListener('bloomreach-banner-click', handleBannerClick);
  });

  onUnmounted(() => {
    document.removeEventListener('bloomreach-banner-click', handleBannerClick);
  });
</script>
